module.exports = __webpack_public_path__ + "static/media/kids_female_actors_temp.5309caa6.jpg";